<template>
    <div class="hk-condition">
        <div class="subject flex">
            <label class="title">选择学科：</label>
            <ul class="flex flex-vertical-center flex-wrap hk-condition-container">
                <li
                    v-for="(item, index) in subjects"
                    :key="index"
                    :class="[
                        { active: defaultSubject === item.id },
                        'hk-condition-item flex flex-center flex-vertical-center'
                    ]"
                    @click="changeSubject(item)"
                >
                    {{ item.name }}
                </li>
            </ul>
        </div>
        <div class="grade flex flex-vertical-center">
            <label class="title">选择年级：</label>
            <ul class="flex flex-vertical-center">
                <li
                    v-for="(item, index) in grades"
                    :key="index"
                    :class="[
                        { active: defaultGrade === item.id },
                        'hk-condition-item flex flex-center flex-vertical-center'
                    ]"
                    @click="changeGrade(item)"
                >
                    {{ item.grade }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { getSubjectList } from '@api/replayList.js';
export default {
    data() {
        return {
            subjects: [{ id: 0, name: '全部' }],
            grades: [
                { id: 0, grade: '全部' },
                { id: 7, grade: '初一' },
                { id: 8, grade: '初二' },
                { id: 9, grade: '初三' },
                { id: 10, grade: '高一' },
                { id: 11, grade: '高二' },
                { id: 12, grade: '高三' }
            ],
            defaultSubject: 0,
            defaultGrade: 0
        };
    },
    created() {
        this.getSubject();
    },
    methods: {
        async getSubject() {
            const { code, data } = await getSubjectList();
            if (code === 0) {
                for (let key in data) {
                    if (data.hasOwnProperty(key)) {
                        let subject = {};
                        subject.id = Number(key);
                        subject.name = data[key];
                        this.subjects.push(subject);
                        subject = {};
                    }
                }
                this.defaultSubject = this.subjects[0].id;
                const params = {
                    subject_id: this.defaultSubject,
                    grade: this.defaultGrade
                };
                this.$emit('initCondition', params);
            }
        },
        changeSubject(item) {
            const { defaultSubject } = this;
            if (defaultSubject === item.id) {
                return false;
            } else {
                this.defaultSubject = item.id;
                this.$emit('changeSubject', item.id);
            }
        },
        changeGrade(item) {
            const { defaultGrade } = this;
            if (defaultGrade === item.id) {
                return false;
            } else {
                this.defaultGrade = item.id;
                this.$emit('changeGrade', item.id);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.hk-condition {
    box-sizing: border-box;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 10px 18px 0px #e4e2e4;
    border-radius: 10px;
    padding: 10px 35px 20px;
    .subject {
        width: 100%;
        padding-bottom: 10px;
        border-bottom: 1px dashed #e1e1e1;
        margin-right: 50px;
    }
    .grade {
        width: 100%;
        margin-right: 50px;
    }
    .title {
        font-size: 16px;
        color: #322d33;
        white-space: nowrap;
        margin-top: 10px;
        height: 28px;
        vertical-align: middle;
        &::after {
            content: '';
            height: 28px;
            display: inline-block;
            vertical-align: middle;
        }
    }
    &-item {
        padding: 0 17px;
        height: 28px;
        border-radius: 14px;
        background: #f2f2f2;
        color: #322d33;
        font-size: 14px;
        cursor: pointer;
        margin-right: 10px;
        margin-top: 10px;
    }
    .active {
        background: #7f008f;
        color: #fff;
        cursor: default;
    }
}
</style>
